<app-configuration-page
  title="Twilio"
  description="Connect your Twilio account so the studio can send text messages to students."
  [breadcrumbs]="[{ label: 'Integrations' }, { label: 'Twilio' }]">

  <app-form-twilio-settings></app-form-twilio-settings>

</app-configuration-page>
